import type { InjectionKey } from 'vue';
import type { GrowthBook } from '@growthbook/growthbook';

export const growthBookKey = Symbol('gb') as InjectionKey<GrowthBook | null>;
